// extracted by mini-css-extract-plugin
export default {"cls1":"fapWoO6ysFCh1hGghT8F","cls2":"sQcCdvKNlbAcE5GVgLtW fapWoO6ysFCh1hGghT8F"};